import React from 'react'
import Layout from '../components/system/layout'
import Meta from '../components/system/meta'
import ErrorPage from '../components/system/error/error-page'
import * as Sentry from '@sentry/node'

const Error = ({ title, message }) => {
  return (
    <Layout>
      <Meta title={title} />
      <ErrorPage title={title} message={message} />
    </Layout>
  )
}

Error.getInitialProps = async ({ res, err }) => {
  if (err) {
    Sentry.captureException(err)
    await Sentry.flush(2000)
  }

  const statusCode = res ? res.statusCode : err ? err.statusCode : null
  const title = statusCode === 404 ? 'Not Found' : `${statusCode ?? 'Unknown'} Error`
  const message =
    statusCode === 404
      ? 'Hmm... That page could not be found.'
      : `A${!!statusCode ? '' : 'n'} ${statusCode ??
          'unknown'} error occurred trying to load the page. Send us an email at pac@allenisd.org if the issue continues.`

  return { statusCode, title, message }
}

export default Error
